import { PropTypes } from "prop-types"
import classNames from "classnames"

import Translate from "../Translate"

const AlertMessage = ({ children, className, accessibilityText, type = "warning" }) => (
  <div className={classNames("oj-alert-message", className, type)} role="alert">
    {accessibilityText && (
      <div className="accessibility-tag">
        <Translate id={accessibilityText} />
      </div>
    )}
    <div className="icon-alert" />
    <div className="messages">{children}</div>
  </div>
)

AlertMessage.propTypes = {
  className: PropTypes.string,
  accessibilityText: PropTypes.string,
  children: PropTypes.node.isRequired,
  type: PropTypes.string
}

export default AlertMessage
